import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSettings } from '../../context/SettingsContext';
import './AutoLogoutPage.css';

const AutoLogoutPage = ({ onBack }) => {
  const { settings, updateSetting } = useSettings();

  const [logoutTime, setLogoutTime] = useState(() => {
    // Load initial value from settings context
    return String(settings.autoLogoutTimer || '0');
  });

  const handleTimeChange = (e) => {
    // Allow only digits
    const digitsOnly = e.target.value.replace(/\D/g, '');
    setLogoutTime(digitsOnly);
  };

  const handleSave = (e) => {
    e.preventDefault();
    // If the input is empty, save it as 0.
    const timeAsNumber = parseInt(logoutTime, 10) || 0;
    updateSetting('autoLogoutTimer', timeAsNumber);
    // We can add a visual confirmation here if needed, e.g., a toast message.
  };

  const handleBack = () => {
    // Revert any unsaved changes by reloading from localStorage
    const savedTime = String(settings.autoLogoutTimer || '0');
    setLogoutTime(savedTime);
    onBack();
  };

  return (
    <div className="auto-logout-page">
      <div className="settings-modal-header">
        <button className="back-button" onClick={handleBack} aria-label="Go back to settings">
          <ion-icon name="chevron-back-outline" />
        </button>
        <span className="settings-section-header">Automatic Logout Timer</span>
      </div>
      <div className="auto-logout-content">
        <form className="auto-logout-form" onSubmit={handleSave}>
          <div className="form-group">
            <label htmlFor="logout-timer-input" className="form-label">
              How long to wait before you are logged out for inactivity (in minutes).
              Set to 0 to disable auto-logout.
            </label>
            <input
              id="logout-timer-input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              className="form-input"
              value={logoutTime}
              onChange={handleTimeChange}
              autoComplete="off"
            />
          </div>
          <div className="auto-logout-footer">
            <button type="submit" className="settings-modal-button primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

AutoLogoutPage.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default AutoLogoutPage;